import React, { createRef } from 'react';
import { IProps, IState, IFormValue } from './types';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { CodeId } from 'constants/enums/codeId.enum';
import { LoginAuthenticateType } from 'constants/enums/loginAuthenticateType.enum';
import sweetAlertService from 'utils/sweetAlertService';
import commonService from 'utils/commonService';

const validationSchema = Yup.object().shape({
  OTP_CODE: Yup.string().required('驗證碼未輸入').length(6, '驗證碼長度不可超過（少於）6 字元。')
});

const initialValues:IFormValue = {
  OTP_CODE: ''
};

/** OTP驗證頁 */
class OTPVerificationForm extends React.Component<IProps, IState> {
  state:IState = {
    unExpired: true,
    timeoutID: null
  }

  private expiredTimeRef = createRef<HTMLSpanElement>();
  private formikRef:any = React.createRef();

  componentDidMount () {
    // console.log('componentDidMount OTPVerificationForm');
    const validitySec = this.handleRestSec(+this.props.otpInfo.VALIDITY);
    this.handleExpiredTimer(validitySec);
  }

  shouldComponentUpdate (prevProps:IProps, prevState:IState) {
    let shouldReRender = prevProps.otpInfo.VALIDITY !== this.props.otpInfo.VALIDITY;
    shouldReRender = shouldReRender || prevState.unExpired !== this.state.unExpired;
    // // console.log('shouldComponentUpdate', shouldReRender);
    return shouldReRender;
  }

  componentDidUpdate () {
    // console.log('componentDidUpdate OTPVerificationForm');
    /** 是否已停止 setTimeOut 事件，與驗證碼未過期(更新後)，重新執行 倒數計時 事件 */
    if (!this.state.timeoutID && this.state.unExpired) {
      this.handleExpiredTimer(+this.props.otpInfo.VALIDITY);
    }
  }

  componentWillUnmount () {
    // console.log('componentWillUnmount OTPVerificationForm');
    clearTimeout(this.state.timeoutID);
  }

  /**
     * @description 執行倒數計時
     */
    handleExpiredTimer = (second:number) => {
      second -= 1;

      second = second > 0 ? second : 0;

      /** 進行秒數轉 分鐘:秒  並顯示 */
      if (this.expiredTimeRef.current) this.expiredTimeRef.current.innerText = this.handleFormatSecond(second);

      /** OTP 驗證碼過期，清除 setTimeOut 事件，更新 State */
      if (second === 0) {
        clearTimeout(this.state.timeoutID);
        this.setState({
          unExpired: false,
          timeoutID: null
        });
        return;
      }

      const timeoutId = setTimeout(() => this.handleExpiredTimer(second), 1000);

      this.setState({
        timeoutID: timeoutId
      });
      // // console.log('timeoutId', timeoutId);
    };

    /**
     * @description 計算剩餘秒數
     */
    handleRestSec = (validitySec:number):number => {
      /** 計算已消耗的秒數 */
      const expendSec = Math.floor((new Date().getTime() - this.props.getOTPTime) / 1000);

      /** 計算剩餘的秒數 */
      const restSec = validitySec - expendSec > 0 ? validitySec - expendSec : 0;

      return restSec;
    };

    /**
     * @description 格式化秒數為 mm:ss
     */
    handleFormatSecond = (second:number) => {
      const min = Math.floor(second / 60);
      const sec = second - (min * 60);

      const minStr = min < 10 ? `0${min}` : `${min}`;
      const secStr = sec < 10 ? `0${sec}` : `${sec}`;

      return `${minStr}:${secStr}`;
    };

    /**
     * @description 發送檢核 OTP 驗證碼
    */
    handleFormSubmit = async (formVal:IFormValue, action:any) => {
      // const otpVerificationReq:VerifyOTPReq = {
      //   SN: this.props.authenticationInfo.SN,
      //   PREFIX_CODE: this.props.authenticationInfo.PREFIX_CODE,
      //   OTP_CODE: formVal.OTP_CODE
      // };
      // // console.log('otpVerificationReq', otpVerificationReq);
      // this.props.onSubmit(formVal.OTP_CODE);
      if (this.state.unExpired) {
        this.props.onSubmit(formVal.OTP_CODE);
      } else {
        action.setFieldError('OTP_CODE', '驗證碼已過期，請重新發送驗證碼');
      }
    };

    /**
     * @description 重新取得 OTP 驗證碼
     */
    handleResentOTP = () => {
      this.props.onResentOTP();
      sweetAlertService.modal({
        html: '驗證碼已送出',
        showCloseButton: true
      });
      this.formikRef.current.setFieldError('OTP_CODE', '');
      this.setState({
        unExpired: true
      });
    };

   /**
    * @description 會員註冊時格式化顯示手機號碼與 Email
   */
   handleFormatTitle = (str:string, formatType:LoginAuthenticateType) => {
     switch (formatType) {
       case LoginAuthenticateType.Mobile:
         return str.replace(/^([\d]{4})[\d]{3}([\d]{3})$/, '$1***$2');
       case LoginAuthenticateType.EmailAddr:
         return str.replace(/^(.*).{3}([@]{1})(.*)$/, '$1***$2$3');
     }
   }

   render () {
     // const expiredTimeRef = createRef<HTMLSpanElement>();

     return (
       <div className="otp-verification-form auth-block">
         <Formik
           innerRef={this.formikRef}
           initialValues={initialValues}
           validationSchema={validationSchema}
           onSubmit={this.handleFormSubmit}
         >
           {(formProps) => (
             <Form>
               <div className="auth-block__row">
                 <h5 className="auth-block__title">輸入驗證碼</h5>
                 {
                   this.props.memberProfile ? (
                     <p className="auth-block__part">
                       已傳送驗證碼至手機號碼
                       <span>{this.handleFormatTitle(this.props.memberProfile.MOBILE, LoginAuthenticateType.Mobile)}</span>
                       及電子信箱
                       <span>{this.handleFormatTitle(this.props.memberProfile.EMAIL_ADDR, LoginAuthenticateType.EmailAddr)}</span>中
                     </p>
                   ) : null
                 }
                 <div className={'element__form-group' + (formProps.errors.OTP_CODE && formProps.touched.OTP_CODE ? ' element__form-group--invalid' : '')}>
                   <Field type="text" name="OTP_CODE" maxLength={6} className="element__input" autoComplete="off" placeholder="請輸入驗證碼" />
                   <div className="element__error-message">
                     <ErrorMessage name="OTP_CODE" />
                   </div>
                 </div>
               </div>
               <div className="auth-block__row">
                 <p className="auth-block__part">{`${commonService.getCodeMsg(this.props.UICode, CodeId.U011)}`} <span ref={this.expiredTimeRef} /> 失效</p>
                 <span className="element__link" onClick={this.props.onUnavailableAuth}>無法取得驗證碼嗎？</span>
               </div>
               <div className="auth-block__row">
                 <button type="submit" className="element__button element__button--red">送出</button>
                 <button type="button" className="element__button element__button--black" disabled={this.state.unExpired} onClick={this.handleResentOTP}>重新送出驗證碼</button>
                 <button type="button" className="element__button element__button--red-border" onClick={this.props.onGoBack}>
                   {
                     this.props.memberProfile ? '返回上一頁' : '返回上一頁，重新選擇'
                   }
                 </button>
               </div>
             </Form>
           )}
         </Formik>
       </div>
     );
   }
};

export default OTPVerificationForm;
